import NewspaperOutlinedIcon from '@mui/icons-material/NewspaperOutlined'
import { isCompanyCountryFrance } from '@/lib/country/entityCountries'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

/**
 * Actualité pharmacie (veille métier résumée IA, modérée a posteriori). Contrat :
 * pharmedigroup-api/docs/ACTU_PHARMACIE.md. Espace Pharmedigroup (pas de `space:
 * SPACE.INDUSTRY`), accessible au titulaire ET à l'équipe (état lu par utilisateur) : ce
 * fichier est spreadé par `getFrontOfficeGroupPharmacien.ts` (titulaire) ET
 * `getFrontOfficeGroupPharmacienAndUserTeam.ts` (équipe), chacun appliquant son propre rôle.
 */
export const routeFrontOfficeGroupNews = [
  {
    route: 'GroupActualites',
    text: 'Actualité',
    t: 'routes.frontoffice.group.actualites',
    icon: NewspaperOutlinedIcon,
    href: '/frontoffice/group/actualites',
    menuHeader: true,
    // Juste après le tableau de bord (position 0) : fil consulté régulièrement.
    position: 15,
    // France uniquement (règle projet n°8). Côté pharmacien, le périmètre pays est celui de
    // SA pharmacie : `dataMyProfile.countries` est le périmètre d'un admin back-office, vide
    // ici. S'en servir masquerait l'entrée pour tout le monde.
    fnDisplay: ({ dataMyProfile }) => isCompanyCountryFrance(dataMyProfile?.selectCompanyDefault),
  },
]

/**
 * Même page pour le compte COMPTOIR (Care), atteinte par le bandeau du header seulement : pas
 * d'entrée de menu, et lecture seule (cf. useNewsAccess, l'API refuse l'écriture d'état).
 *
 * `utility: true` est OBLIGATOIRE (cf. `isUtilityRoute`) : sans lui, cette route serait la
 * seule page Group du comptoir, qui se verrait attribuer l'entité Group et y atterrirait au
 * lieu de son tableau de bord Care (même piège que `getFrontOfficeQrLoginAllUser`). La garde
 * de page (`withAuthSync`) et le repli de `getRoutes` lisent, eux, les routes utilitaires.
 */
export const routeFrontOfficeGroupNewsCounter = [
  {
    ...routeFrontOfficeGroupNews[0],
    menuHeader: false,
    utility: true,
    entity: [EntityList.PHARMEDIGROUP],
    roles: [CONSTANTS.ROLE_COMPTOIR],
  },
]
